import { get, post, encode } from './APIClient';


export function requestResetCode(emailOrValueCode, credentials, onOk, onError) {
    const query = 'ResetPassword/' + emailOrValueCode + '/null/v2/';

    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === 'ok') {
            const registered = Data.bpapi_result.reset_password_step_1.is_value_code_registered;
            const email = Data.bpapi_result.reset_password_step_1.email;
            onOk(registered, email);
        } else {
            console.log("client_error");
            onError();
        }
    }

    get(query, credentials, onDataReceived);

}

/**
 * 
 * @param {*} emailOrValueCode 
 * @param {*} executeId 
 * @param {*} credentials 
 * @param {*} onOk 
 * @param {*} onError 
 * 
 * Possible values for bpapi_result.reset_password_step_2b:
 *  can_reset_password
 *  wrong_execute_id
 *  execute_id_expired
 *  execute_id_used
 */
export function verifyResetCode(emailOrValueCode, executeId, credentials, onOk, onError) {
    /*
        The reason why emailOrValueCode is input after version as well is that Bjørn wants the
        user to be able to input a new email and change that in addition to password with the
        same API method. This is currently not implemented (21.11.17), but the "new value"
        must still be input.
    */

    const query = 'ResetPassword/' + emailOrValueCode + '/' + executeId + '/v2/' + emailOrValueCode + '/';
    const onDataReceived = function response(Data) {
        if (Data.bpapi_status === 'ok') {
            const response = Data.bpapi_result.reset_password_step_2b;
            onOk(response.can_reset_password, response.wrong_execute_id, response.execute_id_expired, response.execute_id_used);
        } else {
            console.log("client_error");
            onError();
        }
    }

    get(query, credentials, onDataReceived);
}

export function setPassword(emailOrValueCode, executeId, newPassword, onOk, onError) {
    const query = 'ResetPassword/'
    const body = 'email_or_value_code=' + emailOrValueCode + '&execute_id=' + executeId + '&app_version=' + 'v2' + '&app_version=' + '&new_email=' + emailOrValueCode + '&new_password=' + encodeURIComponent(newPassword) + "!!!";

    const onDataReceived = function response(Data) {
        if (Data == null) {
            console.log("Data is null");
            onError();
            return;
        }

        if (Data.bpapi_status === 'ok') {
            const response = Data.bpapi_result.reset_password_step_3;
            onOk(response.success);
        } else {
            console.log("client_error");
            onError();
        }
    }

    post(query, body, null, onDataReceived);
}


// WEBPACK FOOTER //
// ./src/Networking/PasswordRecovery.js